import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslationManagementListConfigService } from '../../services/translation-management-list-config/translation-management-list-config.service';
import { MassAddTranslationModalComponent } from '../mass-add-translation-modal/mass-add-translation-modal.component';

@Component({
    selector: 'lib-translation-management',
    templateUrl: './translation-management.component.html',
    styleUrls: ['./translation-management.component.scss'],
    standalone: false
})
export class TranslationManagementComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  languages: Set<string> = new Set<string>();
  private ngbModal = inject(NgbModal);

  constructor(public config: TranslationManagementListConfigService) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  openMassAddTranslationModal(): void {
    const modalRef = this.ngbModal.open(MassAddTranslationModalComponent, { size: 'lg' });
    modalRef.componentInstance.allLanguages = this.config.languages;
    modalRef.componentInstance.config = this.config;
  }
}
